import * as config from "../../i18n.config.json";

export const i18nConfig = {
  supportedLngs: config.supportedLngs,
  fallbackLng: config.fallbackLng,
  defaultNS: "translation",
};
